/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function Fhir(props) {
  const { size, color, ...other } = props;
  return (
    <svg viewBox="0 0 24 24" fill="none" height={size} width={size} {...other}>
      <path
        d="M21 13C21 8.31371 21 10.6863 21 6C21 4.343 19.657 3 18 3H6C4.343 3 3 4.343 3 6V18C3 19.657 4.343 21 6 21H12"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9999 22.5714C18.7956 22.5714 19.5587 22.2564 20.1213 21.6957C20.6839 21.1349 21 20.3744 21 19.5814C21 19.2361 20.908 18.9049 20.8 18.5967C20.1332 19.2533 19.6267 19.5814 19.2799 19.5814C20.878 16.7907 20 15.5947 17.5999 14C17.7999 15.9934 16.4814 16.8999 15.9446 17.4035C15.5067 17.814 15.2026 18.3461 15.0719 18.9309C14.9411 19.5157 14.9896 20.1261 15.2111 20.6831C15.4326 21.2401 15.8169 21.7179 16.3142 22.0546C16.8114 22.3913 17.3987 22.5714 17.9999 22.5714ZM18.2839 15.489C19.5803 16.5854 19.5867 17.4373 18.5851 19.1863C18.2807 19.7177 18.6659 20.3787 19.2799 20.3787C19.5551 20.3787 19.8336 20.299 20.1276 20.1415C20.0404 20.4696 19.878 20.7731 19.6532 21.028C19.4284 21.2829 19.1472 21.4824 18.8319 21.6106C18.5166 21.7388 18.1758 21.7923 17.8362 21.7669C17.4966 21.7416 17.1675 21.638 16.8749 21.4643C16.5824 21.2906 16.3342 21.0516 16.1501 20.7661C15.9659 20.4806 15.8508 20.1564 15.8137 19.819C15.7766 19.4817 15.8187 19.1403 15.9365 18.8219C16.0543 18.5034 16.2447 18.2166 16.4926 17.9839C16.543 17.9369 16.7986 17.7108 16.8098 17.7009C16.9794 17.5494 17.119 17.415 17.257 17.2679C17.7491 16.7425 18.1027 16.1596 18.2835 15.489H18.2839Z"
        fill={color}
      />
      <path
        d="M5 13.3636V9H7.8892V9.76065H5.92259V10.8004H7.69744V11.5611H5.92259V13.3636H5Z"
        fill={color}
      />
      <path
        d="M8.50977 13.3636V9H9.43235V10.8004H11.3052V9H12.2257V13.3636H11.3052V11.5611H9.43235V13.3636H8.50977Z"
        fill={color}
      />
      <path d="M13.9089 9V13.3636H12.9863V9H13.9089Z" fill={color} />
      <path
        d="M14.668 13.3636V9H16.3896C16.7191 9 17.0004 9.05895 17.2333 9.17685C17.4677 9.29332 17.646 9.45881 17.7681 9.6733C17.8917 9.88636 17.9535 10.1371 17.9535 10.4254C17.9535 10.7152 17.891 10.9645 17.766 11.1733C17.641 11.3807 17.4599 11.5398 17.2227 11.6506C16.9869 11.7614 16.7013 11.8168 16.3661 11.8168H15.2134V11.0753H16.217C16.3931 11.0753 16.5394 11.0511 16.6559 11.0028C16.7724 10.9545 16.859 10.8821 16.9158 10.7855C16.9741 10.6889 17.0032 10.5689 17.0032 10.4254C17.0032 10.2805 16.9741 10.1584 16.9158 10.0589C16.859 9.95952 16.7717 9.88423 16.6538 9.8331C16.5373 9.78054 16.3903 9.75426 16.2127 9.75426H15.5906V13.3636H14.668ZM17.0245 11.3778L18.109 13.3636H17.0906L16.0295 11.3778H17.0245Z"
        fill={color}
      />
    </svg>
  );
}

Fhir.defaultProps = {
  color: "currentColor",
  size: 24,
};

Fhir.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
